import { brandColors, brandSemantic } from './brand';

// Recomputed each time the active color palette changes (see brand.js
// `applyPalette`) — call this again after switching palettes rather than
// caching the result.
export const buildTheme = () => ({
  token: {
    colorPrimary: brandSemantic.secondary,
    colorSuccess: brandSemantic.success,
    colorWarning: brandSemantic.warning,
    colorError: brandSemantic.error,
    colorInfo: brandSemantic.info,

    colorText: brandSemantic.text,
    colorTextSecondary: brandSemantic.textSecondary,
    colorTextTertiary: brandSemantic.textTertiary,

    colorBgLayout: brandSemantic.layout,
    colorBgContainer: brandSemantic.surface,
    colorBgElevated: brandSemantic.surface,

    colorBorder: brandSemantic.border,
    colorBorderSecondary: brandSemantic.borderSecondary,

    colorFillSecondary: brandSemantic.primarySoft,
    colorFillTertiary: brandSemantic.roseSoft,
    colorFillQuaternary: '#FCFAF9',

    colorLink: brandSemantic.linkColor,
    colorLinkHover: brandSemantic.linkColorHover,
    colorPrimaryHover: brandSemantic.secondaryHover,

    borderRadius: 10,
    wireframe: false,

    fontFamily: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    Layout: {
      bodyBg: brandSemantic.layout,
      siderBg: brandSemantic.sidebarBg,
      headerBg: brandSemantic.surface,
    },
    Menu: {
      itemBg: brandSemantic.surface,
      itemColor: brandSemantic.textSecondary,
      itemHoverColor: brandSemantic.text,
      itemHoverBg: brandSemantic.primarySoft,
      itemSelectedColor: brandSemantic.text,
      itemSelectedBg: brandColors.rose,
      activeBarBorderWidth: 0,
    },
    Card: {
      colorBgContainer: brandSemantic.surface,
      headerBg: brandSemantic.surface,
      colorBorderSecondary: brandSemantic.borderSecondary,
    },
    Table: {
      headerBg: brandSemantic.tableHeaderBg,
      headerColor: brandSemantic.tableHeaderColor,
      rowHoverBg: brandSemantic.tableHoverBg,
      borderColor: brandSemantic.border,
    },
    Button: {
      primaryShadow: 'none',
      defaultBorderColor: brandSemantic.primaryMuted,
      defaultColor: brandSemantic.text,
      defaultBg: brandSemantic.surface,
    },
    Input: {
      activeBorderColor: brandSemantic.linkColor,
      hoverBorderColor: brandSemantic.linkColor,
      colorBorder: brandSemantic.primaryMuted,
      colorBgContainer: brandSemantic.surface,
    },
    Select: {
      optionSelectedBg: brandSemantic.roseSoft,
      colorBorder: brandSemantic.primaryMuted,
    },
    Tabs: {
      itemColor: brandSemantic.textSecondary,
      itemSelectedColor: brandSemantic.text,
      inkBarColor: brandSemantic.linkColor,
    },
    Tag: {
      defaultBg: brandSemantic.primarySoft,
      defaultColor: brandSemantic.text,
    },
    Modal: {
      contentBg: brandSemantic.surface,
      headerBg: brandSemantic.surface,
    },
  },
});
